import React from 'react';
import PropTypes from 'prop-types';

import LogoWide from '../../assets/images/logo-wide.png';
import useBodyClass from '../../hooks/useBodyClass';

const Login = () => {
  useBodyClass('unauthenticated-page');

  return (
    <div className="unauthenticated">
      <div className="unauthenticated__logo">
        <img src={LogoWide} alt="Pivot Logo" title="Pivot Logo" />
      </div>
      <div className="box">
        <hgroup className="unauthenticated__header">
          <h1>It's time for Pivot Analysis to retire.</h1>

          <p></p>
          <p>
            After several great years slinging data, crunching numbers, and
            finding the best lineups, it's time for Pivot Analysis to bid
            farewell. Our data and services are now offline and unavailable.
          </p>
          <p>
            Reach out at <b>contact@pivotanalysis.com</b> for more information.
          </p>
          <p>
            Thank you to all of our customers, supporters, and contributors over
            the years. We literally couldn't have done it without you.
          </p>
        </hgroup>
      </div>

      <p className="unauthenticated__link">
        <a
          href="https://www.pivotanalysis.com/request-a-quote"
          className="link--negative"
        >
          -- Justin, Morgan, Daniel, and Christien
        </a>
      </p>
    </div>
  );
};

Login.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  onLogIn: PropTypes.func,
  onEmailChange: PropTypes.func,
  onPasswordChange: PropTypes.func,
};

export default Login;
